import {Component, computed, input, output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {TableModule} from 'primeng/table';
import {Select} from 'primeng/select';
import {TooltipModule} from 'primeng/tooltip';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {AgendaItem} from '../demonstration.model';

@Component({
  selector: 'app-demonstration-agenda-table',
  imports: [
    FormsModule,
    TranslocoDirective,
    TableModule,
    Select,
    TooltipModule,
    TranslateDirectusPipe,
  ],
  templateUrl: './demonstration-agenda-table.component.html',
  styleUrl: './demonstration-agenda-table.component.scss',
})
export class DemonstrationAgendaTableComponent {
  items = input.required<AgendaItem[]>();
  readonly = input(false);
  locked = input(false);
  lockedTooltip = input<string | undefined>('');
  expandedIds = input(new Set<number>());

  durationChange = output<{item: AgendaItem; duration: number}>();
  moveUp = output<number>();
  moveDown = output<number>();
  expansionChange = output<number>();

  // Duration options from 0 to 60 minutes in 5-minute steps
  protected readonly durationOptions = computed(() => {
    const options = [];
    for (let i = 0; i <= 60; i += 5) {
      options.push({
        label: this.formatDuration(i),
        value: i,
      });
    }
    return options;
  });

  protected readonly totalDuration = computed(() => {
    return this.items().reduce((sum, item) => sum + item.duration, 0);
  });

  protected formatDuration(minutes: number): string {
    const mins = minutes.toString().padStart(2, '0');
    return `${mins}:00 min`;
  }

  protected isExpanded(id: number): boolean {
    return this.expandedIds().has(id);
  }

  protected toggleExpansion(id: number, event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    this.expansionChange.emit(id);
  }
}
